import { classNames } from 'primereact/utils';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import LandingpageHeader from '../../header/LandingpageHeader';
import styles from '../manager.module.scss';
import { IManagerProfile, ProfileInfo } from '../../../types/Types';
import { useGetManagerProfileListeMutation } from '../../../api/ManagerAPI';
import { LoadingModal } from '../../../component/LoadingModal/LoadingModal';
import Footer from '../../footer/Footer';
import { useWhoamiMutation } from '../../../api/LoginAPI';

export default function ManagerProfileMain() {

  const { t } = useTranslation();
  const navigate = useNavigate();
  
  const [isLoaded, setLoaded] = useState<boolean>(false);
  const [liste, setListe] = useState<IManagerProfile[]>([]);
  const [whoami, setWhoami] = useState<ProfileInfo>();

  const [getProfilesAPI] = useGetManagerProfileListeMutation();
  const [whoamiAPI] = useWhoamiMutation();

  const init = () => {
    setLoaded(false);
    getProfilesAPI().unwrap()
      .then(data => setListe(data))
      .catch((e) => console.log(e))
      .finally(() => setLoaded(true));
  }

  useEffect(() => {
    whoamiAPI().unwrap()
      .then(data => setWhoami(data))
      .catch((e) => console.log(e));
  }, [whoamiAPI]);

  useEffect(() => {
    init();
  }, [getProfilesAPI]);

  return (
    <>
      <div className={classNames(styles.centerContainer)}>

        <LandingpageHeader />

        <div className='container' >

          <button
            onClick={() => {
              navigate({
                pathname: "/",
                search: ""
              });
            }}

            style={{ marginBottom: "20px" }}
            className=' btn btn-outline-primary'
          >
            <i className="bi bi-arrow-left"></i> {t('deTranslation.auftragDetails.backButton')}
          </button>

          <div className={styles['wg-detail-ueb']}>
            <div><span style={{ fontSize: "28pt", fontWeight: "700" }}>Profile von {whoami?.auftraggeber?.name}</span></div>
            <div style={{ textAlign: "end" }}></div>
          </div>
          <button className="btn btn-primary" onClick={() => navigate('detail', { state: { view: 'create' } })}><i className="bi bi-plus"></i><span style={{ marginLeft: "1em" }}>NEU ANLEGEN</span></button>
          
          <div style={{ display: "grid", fontWeight: "bold", gridTemplateColumns: "2fr  2fr 1fr", gap: "10px", alignItems: "center", padding: "10px", marginTop: "10px", border: "1px solid #ccc" }}>
            <div>E-Mail</div>
            <div>Name</div>
            <div style={{ textAlign: "end" }}>
              Option
            </div>
          </div>
          {liste?.map((e, index) =>
            <div key={index}>
              <div key={index} style={{ display: "grid", gridTemplateColumns: "2fr 2fr 1fr", gap: "10px", alignItems: "center", padding: "10px", marginTop: "10px", border: "1px solid #ccc" }}>
                <div>{e.email}</div>
                <div>{e.name}</div>
                <div style={{ textAlign: "end" }}>
                  <button onClick={() => navigate('detail', { state: { view: 'detail', id: e.uid } })} className={styles["wg-a"]} ><i className="bi bi-pencil"></i></button>
                  <button onClick={() => navigate('auftraege', { state: { view: 'detail', id: e.uid } })} className={styles["wg-a"]} ><i className="bi bi-receipt"></i></button>
                </div>
              </div>
            </div>)
          }

        </div>

        <LoadingModal show={!isLoaded} text={"Lade..."} />

      </div>

      <Footer />

    </>
  );
}